import React from 'react';

// Shared expense status badge — extracted in Slice A1 from the duplicated
// copies in Expenses.js and ExpenseDetail.js.
export const STATUS_STYLES = {
  draft: { background: 'rgba(160, 160, 160, 0.15)', color: '#A0A0A0' },
  submitted: { background: 'var(--status-info-bg)', color: 'var(--status-info)' },
  approved: { background: 'var(--status-available-bg)', color: 'var(--status-available)' },
  rejected: { background: 'var(--status-danger-bg)', color: 'var(--status-danger)' },
  paid: { background: 'var(--gold-light)', color: 'var(--gold-primary)' },
  // E5: desaturated danger — related to rejected but visibly its own register.
  voided: { background: 'rgba(239, 68, 68, 0.08)', color: '#F87171' }
};

const StatusBadge = ({ status }) => (
  <span className="status-badge" style={STATUS_STYLES[status] || STATUS_STYLES.draft}>
    {status}
  </span>
);

export default StatusBadge;
